import { render, staticRenderFns } from "./SiteInnerBannerComponent.vue?vue&type=template&id=184dac42"
import script from "./SiteInnerBannerComponent.vue?vue&type=script&lang=js"
export * from "./SiteInnerBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports